import store from "../../../store";
import shopify_export from './shopify_export.vue';

window.shopify_export =  new Vue({
    store,
    el: 'div#shopify_export',

    name : "shopify_export",
    data () {
        return {

        }
    },
    created () {

    },
    components : {
        shopify_export,
    }
});
